"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testRgbEquality = void 0;
var tslib_1 = require("tslib");
var numeric_1 = require("../../../../functions/numeric");
var color_test_values_1 = require("../color-test-values");
var testRgbEquality = function (name, rgb1, rgb2) {
    test(name, function () {
        var _a = tslib_1.__read(rgb1, 3), r1 = _a[0], g1 = _a[1], b1 = _a[2];
        var _b = tslib_1.__read(rgb2, 3), r2 = _b[0], g2 = _b[1], b2 = _b[2];
        expect((0, numeric_1.dist)(r1, r2) < color_test_values_1.epsilon).toBe(true);
        expect((0, numeric_1.dist)(g1, g2) < color_test_values_1.epsilon).toBe(true);
        expect((0, numeric_1.dist)(b1, b2) < color_test_values_1.epsilon).toBe(true);
    });
};
exports.testRgbEquality = testRgbEquality;
